import { Action } from '@ngrx/store';

export class InfoproductsAction implements Action {
  public static getAvailableStrategies =
    '[Infoproducts] get_available_strategies';
  public static getAvailableStrategiesError =
    '[Infoproducts] get_available_strategies_error';
  public static getAvailableStrategiesSuccess =
    '[Infoproducts] get_available_strategies_success';

  public static trialRecommendation = '[Infoproducts] trial_recommendation';
  public static trialRecommendationError =
    '[Infoproducts] trial_recommendation_error';
  public static trialRecommendationSuccess =
    '[Infoproducts] trial_recommendation_success';

  public static getAvailableCourses = '[Infoproducts] get_available_courses';
  public static getAvailableCoursesError =
    '[Infoproducts] get_available_courses_error';
  public static getAvailableCoursesSuccess =
    '[Infoproducts] get_available_courses_success';

  public static setLessonComplete = '[Infoproducts] set_lesson_complete';
  public static setLessonCompleteError =
    '[Infoproducts] set_lesson_complete_error';
  public static setLessonCompleteSuccess =
    '[Infoproducts] set_lesson_complete_success';

  public static getCustomerProducts = '[Infoproducts] get_customer_products';
  public static getCustomerProductsError =
    '[Infoproducts] get_customer_products_error';
  public static getCustomerProductsSuccess =
    '[Infoproducts] get_customer_products_success';

  constructor(public type: string, public payload?: any) {}
}
